import React from "react";
import { Box, Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";

const GetInTouch = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { 
                duration: 0.8,
                ease: "easeOut"
            } 
        },
    };

    const buttonVariants = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: { 
            opacity: 1, 
            scale: 1, 
            transition: { 
                duration: 0.6,
                delay: 0.3 
            } 
        },
        hover: {
            scale: 1.05,
            backgroundColor: "#6d1675",
            color: "#fff",
            transition: { duration: 0.3 }
        }
    };

    return (
        <Box
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
        >
            <Box sx={{ 
                backgroundColor: "#6d1675",
                background: "linear-gradient(135deg, #6d1675 0%, #8a29a3 100%)",
                boxShadow: "0 4px 20px rgba(109, 22, 117, 0.3)",
            }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: { xs: "column", md: "row" },
                        maxWidth: "1200px",
                        mx: "auto",
                        py: 6,
                        px: { xs: 3, md: 4 },
                        color: "#fff",
                        textAlign: { xs: "center", md: "left" },
                        gap: { xs: 3, md: 0 },
                    }}
                >
                    {/* Left Column - Content */}
                    <Box
                        sx={{
                            flex: { xs: "1", md: "0 0 65%" },
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            alignItems: { xs: "center", md: "flex-start" },
                        }}
                    >
                        <Typography 
                            variant="h5" 
                            sx={{ 
                                fontWeight: "bold",
                                fontSize: { xs: "24px", md: "28px" },
                                color: "#fff",
                                mb: 1,
                            }}
                        >
                            Looking to buy in bulk?
                        </Typography>
                        <Typography 
                            variant="body1"
                            sx={{
                                fontSize: { xs: "16px", md: "18px" },
                                color: "rgba(255, 255, 255, 0.9)",
                                lineHeight: 1.6,
                                maxWidth: "500px",
                            }}
                        >
                            Our wholesale team is available and will assist you during the
                            process with personalized service and competitive pricing.
                        </Typography>
                    </Box>

                    {/* Right Column - Button */}
                    <Box
                        sx={{
                            flex: { xs: "1", md: "0 0 35%" },
                            display: "flex",
                            justifyContent: { xs: "center", md: "flex-end" },
                            width: { xs: "100%", md: "auto" },
                        }}
                    >
                        <motion.div
                            variants={buttonVariants}
                            whileHover="hover"
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#ffc20f",
                                    color: "#6d1675",
                                    fontWeight: "bold",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 50,
                                    fontSize: "16px",
                                    textTransform: "none",
                                    minWidth: "160px",
                                    boxShadow: "0 4px 15px rgba(255, 194, 15, 0.3)",
                                    "&:hover": {
                                        backgroundColor: "#6d1675",
                                        color: "#fff",
                                        boxShadow: "0 6px 20px rgba(109, 22, 117, 0.4)",
                                    },
                                }}
                            >
                                Get In Touch
                            </Button>
                        </motion.div>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default GetInTouch;